import React, { useLayoutEffect, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import TraingleChartConsumer from "./traingleColumnChartConsumer";

am4core.useTheme(am4themes_animated);

export default function ServiceCategoryPieChartHbb(props) {
  const [showCategoryChart, setShowCategoryChart] = useState(false);
  const { onNext } = props;

  useLayoutEffect(() => {
    const chart = am4core.create("chartdiv95", am4charts.PieChart);
    chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

    chart.data = props?.data;

    // Add and configure Series
    var pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "litres";
    pieSeries.dataFields.category = "country";

    // Let's cut a hole in our Pie chart the size of 40% the radius
    chart.innerRadius = am4core.percent(40);

    // Set up fills
    pieSeries.slices.template.fillOpacity = 1;

    pieSeries.slices.template.events.on("hit", function (ev) {
      onNext(ev.target.dataItem.properties.category);
    });

    var hs = pieSeries.slices.template.states.getKey("hover");
    hs.properties.scale = 1;
    hs.properties.fillOpacity = 0.5;

    let totalLabel = chart.createChild(am4core.Label);
    totalLabel.text = "SERVICE CATEGORY HBB";
    totalLabel.fontSize = 20;
    totalLabel.align = "center";

    if (props?.total) {
      let totalLabel = chart.createChild(am4core.Label);
      totalLabel.text = `Total: ${props?.total}`;
      totalLabel.fontSize = 20;
      totalLabel.align = "center";
      totalLabel.isMeasured = false;
      totalLabel.x = am4core.percent(50);
      totalLabel.horizontalCenter = "middle";
      totalLabel.y = am4core.percent(46);
      totalLabel.clickable = true;
      totalLabel.events.on("hit", () =>
        props?.total > 0 ? props?.onClickText() : null
      );
      totalLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;
    }

    return () => {
      chart.dispose();
      // chartCbu.dispose();
    };
  }, []);

  if (showCategoryChart) {
    return <TraingleChartConsumer />;
  }

  return (
    <div
      style={{
        width: "100%",
        height: "500px",
        direction: "ltr",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
      }}
    >
      <div
        id="chartdiv95"
        style={{ width: "100%", height: "500px", direction: "ltr" }}
      />
      {/* <div
        id="chartdiv96"
        style={{ width: "40%", height: "350px", direction: "ltr" }}
      /> */}
    </div>
  );
}
